import { Injectable } from '@angular/core';
import { defaults } from '@reenstudio/app/app.config';
import { CER_LIST_MOCK } from '@reenstudio/app/core/mock/cer/cer-list-mock';
import { SITE_LIST_MOCK } from '../mock/site/site-list-mock';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public title = defaults.title;

  getTitle() {
    return this.title;
  }

  getCer() {
    return CER_LIST_MOCK;
  }

  getSite() {
    return SITE_LIST_MOCK;
  }

  reload() {
    window.location.reload();
  }
}
